import styled from '@emotion/styled';

import IconPC from '@/assets/icons/icon_pc.svg';
import IconSP from '@/assets/icons/icon_sp.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const DeviceSelector = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: defaultTheme.spacing.s,
    marginTop: defaultTheme.spacing.xxl,
  }),
);

export const DeviceSelectorButton = styled.button(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: defaultTheme.font.size.s,
    fontWeight: 'bold',
    lineHeight: defaultTheme.font.height.base,
    border: `1px solid ${defaultTheme.border.color.black}`,
    borderRadius: defaultTheme.border.radius.s,
    height: '86px',
    ...hoverOpacity,
  }),
);

const DeviceSelectorIcon = styled.i(() =>
  mq({
    display: 'inline-block',
    width: '48px',
    height: '48px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    marginBottom: defaultTheme.spacing.s,
  }),
);

export const DeviceSelectorIconSP = styled(DeviceSelectorIcon)(() =>
  mq({
    backgroundImage: `url(${IconSP})`,
  }),
);

export const DeviceSelectorIconPC = styled(DeviceSelectorIcon)(() =>
  mq({
    backgroundImage: `url(${IconPC})`,
  }),
);
